import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useLayoutEffect,
  useRef,
} from "react";
import Popover from "@mui/material/Popover";
import Form from "react-bootstrap/Form";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  useSensor,
  useSensors,
  DragOverlay,
  MouseSensor,
  TouchSensor,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { NumericFormat } from "react-number-format";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

import CurrencyInput from "react-currency-input-field";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

import moment from "moment";

const fmtDate = (v) => {
  if (!v) return "";
  const m = moment(v);
  return m.isValid() ? m.format("DD/MM/YYYY") : v;
};

// แสดงตัวเลข 2 ทศนิยม — คืนค่าว่างถ้า null / "" / undefined
const fmtNum = (v) => {
  if (v === "" || v == null) return "";
  const n = Number(v);
  if (isNaN(n)) return "";
  return new Intl.NumberFormat("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export default function ProductRow({
  item,
  index,
  setProductRow,
  columdisplay,
  customSort,
  rowCount,
  addProductRow,
  values,
  setFieldValue,
  formdisabled,
  ...props
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.rowID });

  return (
    <tr className="">
      <td style={customSort ? { paddingLeft: 0 } : {}}>
        {customSort ? (
          <div
            style={{
              paddingLeft: "14px",
              transform: CSS.Transform.toString(transform),
              transition,
            }}
            ref={setNodeRef}
            {...attributes}
            {...listeners}
          >
            <div className="btn-drag"></div>
          </div>
        ) : (
          <div className="flex items-center">
            <div className="mb-1 mr-1">{index + 1}.</div>
            <div className="form-check form-check-st-t1">
              <input
                className="form-check-input"
                type="checkbox"
                name=""
                checked={item.is_checked}
                onChange={(e) => {
                  if (e.target.checked === true) {
                    setProductRow((prev) =>
                      prev.map((el) => {
                        if (el.rowID === item.rowID) {
                          return {
                            ...el,
                            is_checked: true,
                          };
                        }
                        return el;
                      }),
                    );
                  } else {
                    setProductRow((prev) =>
                      prev.map((el) => {
                        if (el.rowID === item.rowID) {
                          return {
                            ...el,
                            is_checked: false,
                          };
                        }
                        return el;
                      }),
                    );
                  }
                }}
              />
            </div>
          </div>
        )}
      </td>
      <td className="column_resizer_body" />
      <td>
        {item.documentNumber}
      </td>
      <td className="column_resizer_body" />
      <td>{fmtDate(item.documentDate)}</td>
      <td className="column_resizer_body" />

      <td>{item.quantity}</td>
      <td className="column_resizer_body" />
      <td className="text-end">
        {fmtNum(item.taxable_amount ?? item.excludeVat)}
      </td>
      <td className="column_resizer_body" />

      {columdisplay.vat && (
        <>
          <td className="text-end">{fmtNum(item.vat)}</td>
          <td className="column_resizer_body" />
        </>
      )}

      <td className="text-end">{fmtNum(item.total_amount ?? item.netValue)}</td>
      <td className="column_resizer_body" />

      {columdisplay.remark && (
        <>
          <td>
            <input
              type="text"
              className={`form-control formv text-start h-[35px] border-0 me-2${formdisabled ? " !bg-white" : ""}`}
              value={item.remark ?? ""}
              disabled={formdisabled}
              onChange={(e) => {
                setProductRow((prev) =>
                  prev.map((el) => {
                    if (el.rowID === item.rowID) {
                      return {
                        ...el,
                        remark: e.target.value,
                      };
                    }
                    return el;
                  }),
                );
              }}
            />
          </td>
          <td className="column_resizer_body" />
        </>
      )}

      <td>
        {(item.id || item.member_debt_transaction_id || item.documentNumber) && !formdisabled ? (
          <IconButton
            aria-label="delete"
            className="!bg-[#F95057]"
            size="small"
            onClick={() =>
              setProductRow((prev) =>
                prev.filter((el) => el.rowID !== item.rowID),
              )
            }
          >
            <DeleteIcon className="!text-[#FFF] !text-sm" />
          </IconButton>
        ) : (
          ""
        )}
      </td>
      <td className="column_resizer_body" />
    </tr>
  );
}
